import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";

const values = [
  { icon: "ri-compass-3-line", title: "为幻想而聚", desc: "专注异世界、穿越、奇幻、脑洞、玄幻五大题材，做最懂幻想读者的聚合站。" },
  { icon: "ri-award-line", title: "口碑第一", desc: "以读者评分与人气为依据，让真正好看的作品被更多人看见。" },
  { icon: "ri-flashlight-line", title: "持续更新", desc: "热门榜单与今日更新每日同步，追更体验不间断。" },
  { icon: "ri-heart-line", title: "尊重创作", desc: "倡导支持正版，为每一份认真创作的幻想故事发声。" },
];

const testimonials = [
  { name: "读者·阿辞", text: "作为一个重度玄幻控，虚空漫画的榜单太对我胃口了，几乎每天都有新发现，书荒彻底终结。" },
  { name: "读者·林小满", text: "完本推荐栏目简直是救星，一口气追完《深渊图书馆》，爽到起飞，评分也很靠谱。" },
  { name: "读者·木木", text: "界面很舒服，分类清楚，脑洞题材的推荐总能挖到宝藏，已经安利给整个追漫群了。" },
];

export default function About() {
  return (
    <div className="pt-16 md:pt-[72px]">
      <Seo
        title="关于我们 | 虚空漫画网"
        description="虚空漫画网是一个专注于异世界、穿越、奇幻、脑洞、玄幻题材的漫画聚合站，以每日更新的热门榜单与完本推荐，为书荒读者找到下一部入坑作。"
        path="/about"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于我们",
            url: "https://talespots.github.io/about",
            description: "虚空漫画网的品牌介绍、定位、发展理念与内容原则。",
          },
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "虚空漫画网",
            url: "https://talespots.github.io",
            description: "聚合异世界、穿越、奇幻、脑洞、玄幻题材漫画的聚合站，每日更新热门榜单与完本推荐。",
          },
        ]}
      />

      <section className="relative overflow-hidden border-b border-background-800 bg-background-900/60">
        <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-accent-500/15 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-16 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl" />
        <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6 md:py-20">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-background-950/50 px-4 py-1.5 text-xs font-medium text-primary-300">
            <i className="ri-quill-pen-line text-sm" />
            关于我们
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            为每一个<span className="text-gradient-gold">幻想读者</span><br className="hidden md:block" /> 而生的漫画聚合站
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-foreground-500 md:text-lg">
            虚空漫画网诞生于一个朴素的想法：把散落在各处的异世界、穿越、奇幻、脑洞、玄幻佳作聚到一起，用每日更新的榜单和完本推荐，替每位读者省下淘书的时间。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-400">我们的定位</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">书荒终结者，而非内容生产商</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-500 md:text-base">
              我们并不创作漫画，而是专注于「发现」与「整理」。围绕异世界、穿越、奇幻、脑洞、玄幻五大题材，持续筛选、分类、更新，把真正值得一看的作品推到你面前。热门榜单的每一次刷新，完本推荐里的每一部佳作，都经过我们对热度、评分与人气增速的综合考量。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/category/all" className="cursor-pointer whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600">
                去逛分类
              </Link>
              <Link to="/contact" className="cursor-pointer whitespace-nowrap rounded-lg border border-background-700 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-300">
                联系我们
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((v) => (
              <div key={v.title} className="rounded-xl border border-background-800 bg-background-900 p-5 transition-colors hover:border-primary-500/40">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/15 text-xl text-primary-400">
                  <i className={v.icon} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-500">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-background-800 bg-background-900/60">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="text-center">
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-400">读者口碑</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">他们在这里找到下一部入坑作</h2>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-2xl border border-background-800 bg-background-950 p-6">
                <span className="flex items-center gap-1 text-primary-400">
                  {[0, 1, 2, 3, 4].map((i) => <i key={i} className="ri-star-fill text-sm" />)}
                </span>
                <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-500">「{t.text}」</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500/20 font-heading text-sm font-bold text-primary-400">
                    {t.name.replace("读者·", "").slice(0, 1)}
                  </span>
                  <span className="text-sm text-foreground-800">{t.name}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-3xl border border-primary-500/30 bg-gradient-to-br from-background-900 via-background-900 to-accent-500/10 px-6 py-12 text-center md:px-12">
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">一起建设这个幻想世界</h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-foreground-500 md:text-base">
            有好作品想推荐？对榜单有想法？欢迎告诉我们。你的每一次反馈，都在让虚空漫画网变得更好。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact" className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600">
              与我们联系
            </Link>
            <Link to="/category/all" className="cursor-pointer whitespace-nowrap rounded-full border border-background-700 px-7 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-500/50 hover:text-primary-300">
              去挑一部漫画
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}